// src/pages/enrollment/EnrollmentForm.jsx
import React, { useState, useEffect, use } from 'react';
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Form,
  FormGroup,
  Label,
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormText,
  Table,
} from 'reactstrap';
import Select from 'react-select';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';

import { toast } from 'react-toastify';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import useVendorBranch from '../../utils/useVendorBranch';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import TimeSelector from '../../components/TimeSelector';
import { addDuration, getToday } from '../../constants/DateFormatter';
import { formatDate } from '../../constants/DateFormatter';

const EnrollmentForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state;

  const sessionData = useSelector((state) => state.sessionState);
  const { user } = useSelector((state) => state.authState);

  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const [errorMessage, setErrorMessage] = useState({});
  const [sessionOptions, setSessionOptions] = useState([]); // [{value,label}]
  const [courseFormat, setCourseFormat] = useState('');
  const [totSems, setTotSems] = useState(0);
  const [rawClasses, setRawClasses] = useState([]);
  const [classes, setClasses] = useState([]);
  const [faculty, setFaculty] = useState([]);
  const [batches, setBatches] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [MultiPurposeMaster, setMultiPurposeMaster] = useState([]);
  const [installmentList, setInstallmentList] = useState([]);
  const [SlabMasterList, setSlabMasterList] = useState([]);
  const [Fee_Group_data, setFee_Group_data] = useState([]);
  const [feeDueList, setFeeDueList] = useState([]);
  const [circleTable, setCircleTable] = useState([]);
  // ✅ NEW: credential button loading
  const [credLoading, setCredLoading] = useState(false);
  const [isCredSubmitting, setIsCredSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    enrollment_id: 0,
    vendor_id: 0,
    branch_id: 0,
    student_id: '',
    student_name: '', // proper student name
    course_selection_id: 0,
    faculty_selection_id: 0,
    course_dropdown: '',
    faculty_dropdown: '',
    batch_id: '',
    orderNumber: '',
    admit_no: '', // full display (e.g. "4689 - RIDA - NASIR")
    course_name: '',
    faculty_name: '',
    batch_name: '', // sirf NAME (e.g. "TRP123")
    admit_no: '', // numeric admission no as string (e.g. "4689")
    disc_applicable: '',
    disc_recommended_by: '',
    disc_remark: '',
    fee_installment_mode: '',
    slab_id: 0,
    fee_group_id: 0,
    slab_fee_tot: 0,
    disc_tot: 0,
    fee_tot: 0,
    total_semester: 0,
    month_tot_1: 0,
    month_tot_2: 0,
    month_tot_3: 0,
    month_tot_4: 0,
    month_tot_5: 0,
    month_tot_6: 0,
    month_tot_7: 0,
    month_tot_8: 0,
    month_tot_9: 0,
    month_tot_10: 0,
    month_tot_11: 0,
    month_tot_12: 0,
    session_year: '',
  });

  const [installmentType, setInstallmentType] = useState('');
  const [studRecords, setStudRecords] = useState([]);
  const [autoCompleteValue, setAutoCompleteValue] = useState(null);

  const [discountModal, setDiscountModal] = useState(false);
  const [discountErrors, setDiscountErrors] = useState({});

  const [discountMasterData, setDiscountMasterData] = useState({
    id: 0,
    disc_circle_id: 0,
    disc_amt: '',
    disc_remark: '', // "2:30 PM"
  });

  // -------- Batch Modal ----------
  const [batchModal, setBatchModal] = useState(false);
  const [batchErrors, setBatchErrors] = useState({});

  const [batchMasterData, setBatchMasterData] = useState({
    id: 0,
    batch_name: '',
    batch_code: '',
    batch_start_time: '',
    batch_end_time: '',
    batch_start_date: getToday(),
    batch_end_date: '',
    faculty_id: 0,
  });

  // =========================
  //  BATCH MODAL HANDLERS
  // =========================
  const toggleBatchModal = async () => {
    if (
      !formData.course_selection_id ||
      formData.course_selection_id === 0 ||
      !formData.course_name?.trim() ||
      !rawClasses.length
    ) {
      toast.error('Please select a Course first to add new Batches');
      return;
    }

    const isOpening = !batchModal;
    setBatchModal(isOpening);

    if (isOpening) {
      setBatchErrors({});

      let defaultCode = '';

      const cls = (rawClasses || []).find(
        (x) => Number(x.id) === Number(formData.course_selection_id),
      );

      // console.log(cls);
      const endDate = addDuration(getToday(), cls.duration);
      // console.log("Calculated end date:", endDate);

      const raw =
        (cls && (cls.class_code || cls.class_display_name || cls.className)) ||
        '';

      const upper = raw.toString().trim().toUpperCase();
      const cleaned = upper.replace(/[^A-Z0-9]/g, '');
      defaultCode = cleaned.substring(0, 3);

      const batchCode = await getBatchCode(formData.course_selection_id);

      setBatchMasterData({
        id: 0,
        batch_name: cls.class_Name ? `${cls.class_Name} Batch` : 'Batch',
        batch_code: batchCode ? batchCode : defaultCode,
        batch_start_date: getToday(),
        batch_end_date: endDate,
      });
    }
  };

  const onBatchInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'batch_start_date') {
      const cls = (rawClasses || []).find(
        (x) => Number(x.id) === Number(formData.course_selection_id),
      );

      // console.log(cls);
      const endDate = addDuration(value, cls.duration);

      setBatchMasterData((prev) => ({
        ...prev,
        [name]: value,
        batch_end_date: endDate,
      }));
    } else {
      setBatchMasterData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    setBatchErrors((prev) => ({
      ...prev,
      [name]: '',
    }));
  };

  const validateBatch = () => {
    const errors = {};
    if (isSuperAdmin) {
      if (!formData.vendor_id || Number(formData.vendor_id) <= 0) {
        toast.error('Please select a Vendor');
        return false;
      }
    }

    // Admin OR multi-branch user → must select branch
    if (isSuperAdmin || isAdmin || hasMultiBranch) {
      // Validate Semester (must be a number > 0)
      if (!formData.branch_id || Number(formData.branch_id) <= 0) {
        toast.error('Please select a Branch');
        return false;
      }
    }

    if (!batchMasterData.batch_name?.trim()) {
      errors.batch_name = 'Batch name is required';
    }
    if (!batchMasterData.batch_code?.trim()) {
      errors.batch_code = 'Batch code is required';
    }

    if (!batchMasterData.batch_start_time?.trim()) {
      errors.batch_start_time = 'Batch start time is required';
    }
    if (!batchMasterData.batch_end_time?.trim()) {
      errors.batch_end_time = 'Batch end time is required';
    }
    if (!batchMasterData.batch_start_date?.trim()) {
      errors.batch_start_date = 'Batch start date is required';
    }
    if (!batchMasterData.batch_end_date?.trim()) {
      errors.batch_end_date = 'Batch end date is required';
    }
    if (
      new Date(batchMasterData.batch_end_date) <
      new Date(batchMasterData.batch_start_date)
    ) {
      errors.batch_end_date = 'Batch end date must be after start date';
    }
    if (
      !batchMasterData.faculty_id ||
      Number(batchMasterData.faculty_id) <= 0
    ) {
      errors.faculty_id = 'Faculty is required';
    }
    return errors;
  };
  const buildBranchIdAndNames = async (vendorId, branchId) => {
    try {
      const vid = Number(vendorId || 0);
      const bid = Number(branchId || 0);
      if (!vid || !bid) return '';

      // your API from Faculty code
      const url = `/api/BranchMaster/all?pageNo=1&limit=100000&searchKey=&venderMasterId=${vid}`;
      const res = await apiService.get(url);

      if (res?.status === true) {
        const arr = Array.isArray(res?.branchMasterData)
          ? res.branchMasterData
          : [];
        const row = arr.find((b) => Number(b?.id || 0) === bid);
        const name = String(row?.branch_name || '').trim();
        return name ? `${bid}-${name}` : String(bid);
      }

      return String(bid);
    } catch (e) {
      console.log(e);
      return String(branchId || '');
    }
  };

  // =========================
  // ✅ Create Student Credentials (Enrollment)
  // =========================
  const handleCreateStudentCredentials = async () => {
    if (isCredSubmitting) return;

    // Must be edit mode
    const enrollmentId = Number(formData.enrollment_id || 0);
    if (!enrollmentId) {
      toast.error('Please save enrollment first');
      return;
    }

    // Vendor/Branch validation (same as others)
    if (
      isSuperAdmin &&
      (!formData.vendor_id || Number(formData.vendor_id) <= 0)
    ) {
      toast.error('Please select a Vendor');
      return;
    }
    if (
      (isSuperAdmin || isAdmin || hasMultiBranch) &&
      (!formData.branch_id || Number(formData.branch_id) <= 0)
    ) {
      toast.error('Please select a Branch');
      return;
    }

    // Student validation
    if (!formData.student_name?.trim()) {
      toast.error('Student name is required');
      return;
    }

    // Find selected admission record to get phone/email
    const selectedAdm = autoCompleteValue
      ? autoCompleteValue
      : (studRecords || []).find(
          (x) => String(x?.id) === String(formData.student_id),
        );

    const mobile =
      selectedAdm?.stud_ph_no ||
      selectedAdm?.mobile ||
      selectedAdm?.phone ||
      '';

    const email = selectedAdm?.email || selectedAdm?.stud_email || '';

    if (!mobile || String(mobile).trim().length < 10) {
      toast.error('Student mobile not found (from Admission)');
      return;
    }

    setIsCredSubmitting(true);
    setCredLoading(true);

    try {
      const vendorId = Number(formData.vendor_id || 0);
      const branchId = Number(formData.branch_id || 0);
      const branchIdAndNames = await buildBranchIdAndNames(vendorId, branchId);

      // ✅ payload same as faculty BUT includes tbl_linked_with + tbl_link_id
      const params = {
        vender_master_id: vendorId,
        branch_id: branchId,
        branch_id_and_names: branchIdAndNames,

        sponsored_user_mobile: String(mobile),
        user_name: String(formData.student_name || '').trim(),
        user_mobile: String(mobile),
        user_pass: String(mobile),
        confirm_user_pass: String(mobile),
        user_email: String(email || '').trim(),

        // ✅ profile id for STUDENT (change if your student profile id differs)
        user_profile_id: 11,

        working_bussinesss_mode: 'SCHOOL',
        user_status: 'ACTIVE',

        // ✅ NEW FIELDS (ONLY Enrollment)
        tbl_linked_with: 'ENROLLMENT_MASTER',
        tbl_link_id: enrollmentId,
      };

      const response = await apiService.post(
        `api/admin/User_Detail/branch/CreateUser`,
        params,
      );

      if (response?.status === true) {
        toast.success(response.message || 'Student user created');
      } else {
        toast.error(response?.message || 'Failed to create student user');
      }
    } catch (err) {
      console.log(err);
      toast.error('SomeThing went wrong!!');
    } finally {
      setCredLoading(false);
      setIsCredSubmitting(false);
    }
  };

  // =========================
  //  Discount MODAL HANDLERS
  // =========================
  const toggleDiscountModal = (discountRow) => {
    const isOpening = !discountModal;
    setDiscountModal(isOpening);

    if (isOpening) {
      setDiscountErrors({});
      setDiscountMasterData({
        id: discountRow.id ? discountRow.id : 0,
        disc_circle_id: discountRow.circle_id ? discountRow.circle_id : 0,
        disc_amt: discountRow.disc_amt ? discountRow.disc_amt : '',
        disc_remark: discountRow.disc_remark ? discountRow.disc_remark : '',
      });
    }
  };

  const onDiscInputChange = (e) => {
    const { name, value } = e.target;
    setDiscountMasterData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setDiscountErrors((prev) => ({
      ...prev,
      [name]: '',
    }));
  };

  // =========================
  //  REMOTE SEARCH HELPERS
  // =========================
  const GetCircleMaster = async () => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/CircleMaster/GetCircleMaster`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        const totalSem = totSems;

        const filteredOptions = response.data
          .filter((item) => {
            const num = parseInt(item.circle_name);

            // Keep non-sem values (Monthly/Yearly etc.)
            if (isNaN(num)) return true;

            // Keep only semester numbers <= totalSem
            return num <= totalSem;
          })
          .map((item) => {
            const num = parseInt(item.circle_name);
            return {
              ...item,
              // Rename only sem numbers
              circle_name: !isNaN(num)
                ? `${courseFormat} ${num}`
                : item.circle_name,
            };
          });

        setCircleTable(filteredOptions);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error('SomeThing went wrong!!');
    }
  };

  const fetchClasses = async (searchText) => {
    try {
      const res = await apiService.get(
        `api/ClassMaster/GetClassMaster?vendorId=${formData.vendor_id}&branchId=${formData.branch_id}&searchItem=${encodeURIComponent(
          searchText || '',
        )}`,
      );

      if (res.status === true) {
        const classesRaw = res?.data;
        setRawClasses(classesRaw);

        const classOptions = (classesRaw || []).map((x) => ({
          value: x.id,
          label: x.class_Name ?? x.class_display_name ?? 'No Name',
        }));
        setClasses(classOptions);
      } else {
        toast.error(res.message || 'Failed to fetch');
      }
    } catch (err) {
      console.log(err);
      alert('Failed to load courses');
    }
  };

  const fetchFaculty = async (searchText) => {
    try {
      const res = await apiService.get(
        `api/FacultyMaster/GetAllFaculty?vendorId=${formData.vendor_id}&branchId=${formData.branch_id}&search=${encodeURIComponent(
          searchText || '',
        )}`,
      );

      if (res.status === true) {
        const facultyRaw = res.data;
        setFaculty(
          facultyRaw.map((x) => ({
            value: x.faculty_id,
            label: x.faculty_name,
          })),
        );
      } else {
        toast.error(res.message || 'Failed to fetch');
      }
    } catch (err) {
      console.log(err);
      toast.error('Failed to load faculty');
    }
  };

  const fetchBatches = async (course_selection_id = 0, searchText = '') => {
    //setBatches([]);
    try {
      const res = await apiService.get(
        `api/BatchMaster/GetAllBatch?vendorId=${formData.vendor_id}&branchId=${formData.branch_id}&classId=${course_selection_id}&search=${encodeURIComponent(
          searchText,
        )}`,
      );

      if (res.status === true) {
        const list = res.data || [];
        setBatches(
          list.map((x) => ({
            value: x.id,
            label: x.batch_code
              ? `${x.batch_code}`
              : 'Batch code not found',
          })),
        );
      } else {
        toast.error(res.message || 'Failed to fetch batches');
      }
    } catch (err) {
      console.log(err);
      toast.error('Failed to load batches');
    }
  };

  const getBatchCode = async (classId) => {
    try {
      const response = await apiService.get(
        `api/BatchMaster/NewBatchCode?vendorId=${formData.vendor_id}&branchId=${formData.branch_id}&classId=${classId}`,
      );

      if (response.response && response.response.data?.errors) {
        toast.error(response.response.data.errors);
      }

      if (response.status === true) {
        return response.message;
        // setBatchMasterData((prev) => ({
        //   ...prev,
        //   batch_code: response.message || '',
        // }));
      } else {
        toast.error(response.message || 'Failed to fetch');
      }
    } catch (error) {
      console.error(error);
      toast.error('SomeThing went wrong');
    }
  };
  const fetchSessions = async (searchText = '') => {
    try {
      const vendorId = formData.vendor_id || '';
      const branchId = formData.branch_id || '';

      const res = await apiService.get(
        `api/SessionMaster/GetAllSession?vendorId=${vendorId}&branchId=${branchId}&search=${encodeURIComponent(searchText || '')}`,
      );

      const container = res?.data ?? res;

      const list =
        (Array.isArray(container?.data) && container.data) ||
        (Array.isArray(container?.Data) && container.Data) ||
        (Array.isArray(container) && container) ||
        [];

      const opts = list
        .map((x) => {
          const id = x.id ?? x.ID ?? x.session_id ?? 0;
          const name = x.session_name ?? x.sessionName ?? x.name ?? '';
          return { value: String(id), label: String(name) };
        })
        .filter((x) => x.value !== '0' && x.label);

      setSessionOptions(opts);
    } catch (err) {
      console.error(err);
      setSessionOptions([]);
    }
  };

  const loadBatchesByCourse = async (course_selection_id) => {
    await fetchBatches(course_selection_id, '');
  };

  const saveBatchMaster = async () => {
    try {
      const errors = validateBatch();
      if (Object.keys(errors).length > 0) {
        setBatchErrors(errors);
        // console.log("Batch validation errors:", errors);
        return;
      }

      const config = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      const selectedClassOption = (classes || [])
        .map((x) => ({
          value: String(x.id),
          label: x.class_display_name ?? x.className ?? 'No Name',
        }))
        .find((o) => o.value === formData.course_selection_id);

      const payloadObj = {
        id: batchMasterData.id,
        vendor_id: formData.vendor_id,
        branch_id: formData.branch_id,
        faculty_id: batchMasterData.faculty_id,
        batch_name: batchMasterData.batch_name,
        batch_code: batchMasterData.batch_code,
        batch_start_time: batchMasterData.batch_start_time,
        batch_end_time: batchMasterData.batch_end_time,
        batch_start_date: batchMasterData.batch_start_date,
        batch_end_date: batchMasterData.batch_end_date,
        class_id: formData.course_selection_id
          ? parseInt(formData.course_selection_id, 10)
          : 0,
        class_name: selectedClassOption?.label || '',
      };

      // console.log(formData.course_selection_id,"course id before payload");
      // console.log('Payload batch:', payloadObj);
      // return;

      const payload = JSON.stringify(payloadObj);

      let res;
      if (batchMasterData.id && batchMasterData.id !== 0) {
        res = await apiService.put(
          `api/BatchMaster/UpdateBatch?id=${batchMasterData.id}`,
          payload,
          config,
        );
      } else {
        res = await apiService.post(
          'api/BatchMaster/AddBatch',
          payload,
          config,
        );
      }
      // console.log(formData.course_selection_id,"course id after payload");
      // console.log('BatchMaster response ==>', res);

      const status = res.status ?? res.Status ?? false;
      const message = res.message ?? res.Message ?? '';

      if (status) {
        const dataArr = res.data;

        const first =
          Array.isArray(dataArr) && dataArr.length > 0 ? dataArr[0] : null;
        toast.success(message || 'Batch saved successfully');

        toggleBatchModal();

        if (first) {
          const name = first.batch_name ?? first.batchName ?? 'No Name';
          const code = first.batch_code ?? first.batchCode ?? '';

          const option = {
            value: String(first.id),
            label: code ? `${code} - ${name}` : name,
            nameOnly: name, // sirf name
          };

          // setBatches((prev) => {
          //   const others = (prev || []).filter((x) => x.value !== option.value);
          //   return [...others, option];
          // });

          setFormData((prev) => ({
            ...prev,
            batch_id: first.id,
            batch_name: first.batch_name, // Enrollment me sirf "TRP123"
          }));
        }

        if (formData.course_selection_id) {
          fetchBatches(formData.course_selection_id, first.batch_name);
        } else {
          setBatches([]);
        }
      } else {
        if (message && message.toLowerCase().includes('batch code')) {
          setBatchErrors((prev) => ({
            ...prev,
            batch_code: message,
          }));
        } else {
          alert(message || 'Failed to save batch');
        }
      }
    } catch (err) {
      console.log(err);
      alert('Something went wrong while saving batch');
    }
  };

  const validateDiscount = () => {
    const errors = {};

    if (
      !discountMasterData.disc_amt ||
      Number(discountMasterData.disc_amt) <= 0
    ) {
      errors.disc_amt = 'Discount amount is required';
    }
    if (
      !discountMasterData.disc_circle_id ||
      Number(discountMasterData.disc_circle_id) <= 0
    ) {
      errors.disc_circle_id = 'Discount applicability criterion is required';
    }
    return errors;
  };

  const saveDiscount = async () => {
    try {
      const errors = validateDiscount();
      if (Object.keys(errors).length > 0) {
        setDiscountErrors(errors);
        return;
      }

      const config = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      const payloadObj = {
        id: discountMasterData.id,
        enrollment_id: formData.enrollment_id,
        disc_amt: parseFloat(discountMasterData.disc_amt),
        disc_circle_id: parseInt(discountMasterData.disc_circle_id),
        disc_remark: discountMasterData.disc_remark,
      };

      // console.log('Payload discount:', payloadObj);
      //return;

      const payload = JSON.stringify(payloadObj);

      let res = await apiService.put(
        'api/Enrollment/ApproveDiscount',
        payload,
        config,
      );
      // console.log(formData.course_selection_id,"course id after payload");
      // console.log('BatchMaster response ==>', res);

      const status = res.status;
      const message = res.message;

      if (status) {
        toast.success(message || 'Discount saved successfully');
        getEnrollmentById(formData.enrollment_id);
        setDiscountMasterData({
          id: 0,
          disc_circle_id: 0,
          disc_amt: 0,
          disc_remark: '',
        });
        toggleDiscountModal();
      } else {
        toast.error(message || 'Failed to save discount');
      }
    } catch (err) {
      console.log(err);
      alert('Something went wrong while saving discount');
    }
  };

  // ---------- Admission search ----------
  const GetAdmission = async (search, selectedAdmNo) => {
    try {
      // if (!search) {
      //   setStudRecords([]);
      //   return;
      // }

      const response = await apiService.get(
        `api/Admission/GetAdmission?vendorId=${formData.vendor_id}&branchId=${formData.branch_id}&search=${encodeURIComponent(search)}`,
      );

      if (response.response && response.response.data?.errors) {
        alert(response.response.data.errors);
      }

      if (response.status === true) {
        const list = response.data || [];
        setStudRecords(list);

        const admToSelect = selectedAdmNo || search;

        if (admToSelect) {
          const match = list.find((s) => s.admit_no === admToSelect);
          if (match) {
            setAutoCompleteValue(match);
            setFormData((prev) => ({
              ...prev,
              admit_no: match.admit_no, // display
              student_id: match.id ? String(match.id) : prev.student_id,
              student_name: match.stud_name || prev.student_name,
              admit_no: match.admit_no || prev.admit_no, // string hi
            }));
          }
        }
      } else {
        alert(response.message);
      }
    } catch (error) {
      console.log(error);
      alert('Something went wrong!!');
    }
  };

  const onHandleBack = () => {
    navigate(-1);
  };

  const getEnrollmentById = async (id) => {
    try {
      const response = await apiService.get(
        `api/Enrollment/GetEnrollmentById?id=${id}`,
      );

      if (response.response && response.response.data?.errors) {
        toast.error(response.response.data.errors);
      }

      if (response.status === true) {
        setFormData(response.singleRecord);
        setFeeDueList(response.studentFeeDueRecList);
      } else {
        toast.error(response.message || 'Failed to fetch');
      }
    } catch (error) {
      console.error(error);
      toast.error('SomeThing went wrong');
    }
  };

  const getInstallments = async (id) => {
    try {
      const response = await apiService.get(
        `api/Enrollment/GetInstallments?enrollmentNo=${id}`,
      );

      if (response.response && response.response.data?.errors) {
        toast.error(response.response.data.errors);
      }

      if (response.status === true) {
        setInstallmentList(response.studentFeeInstallments);
      } else {
        toast.error(response.message || 'Failed to fetch');
      }
    } catch (error) {
      console.error(error);
      toast.error('SomeThing went wrong');
    }
  };

  useEffect(() => {
    if (!location?.state) return;
    setFormData(location.state);
    setInstallmentType(location.state.fee_installment_mode);
    getEnrollmentById(location.state.enrollment_id);
    getInstallments(location.state.enrollment_id);

    const selClass = rawClasses.find(
      (c) => c.id === location.state.course_selection_id,
    );
    if (selClass) {
      setTotSems(selClass.total_semester);
      const structure =
        selClass?.course_structure === 'year'
          ? selClass.course_structure.toUpperCase()
          : selClass?.course_structure?.slice(0, 3).toUpperCase();
      setCourseFormat(structure || 'SEM');
    }
  }, [location?.state, rawClasses]);

  useEffect(() => {
    const { vendor_id, branch_id } = formData;

    // Apply conditionalDataLoad EVERYWHERE (normal + edit)
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: vendor_id,
      branchId: branch_id,
    });

    if (!canLoad) return;
    fetchSessions('');
    // 1. Load normal dropdowns
    fetchClasses('');
    fetchFaculty('');
    GetAdmission('', '');
    //fetchBatches(vendor_id, branch_id);
    GetFee_GroupData();
    Get_All_Multi_Purpose_Type_Master();

    // 2. Edit mode dependent calls
    if (location?.state) {
      const {
        admit_no,
        course_selection_id,
        faculty_name,
        course_name,
        fee_group_id,
        slab_id,
      } = location.state;
      //load student details
      if (admit_no) {
        GetAdmission(admit_no, admit_no);
      }
      //load class details

      if (course_name) {
        fetchClasses(course_name);
      }
      //load bactch details

      if (course_selection_id) {
        fetchBatches(course_selection_id, '');
      }

      //load faculty details
      if (faculty_name) {
        fetchFaculty(faculty_name);
      }

      if (fee_group_id && course_selection_id) {
        GetSlabMasterByFeeGroupID(fee_group_id, course_selection_id);
      }
    }
  }, [formData.vendor_id, formData.branch_id]);

  useEffect(() => {
    GetCircleMaster();
  }, [totSems]);

  const onSelectChange = (field, option) => {
    setFormData((prev) => {
      const updated = {
        ...prev,
        [field]: option?.value ?? '',
      };

      //console.log('Select changed:', field, option, option?.value,updated);

      if (field === 'course_selection_id') {
        const selClass = rawClasses.find((c) => c.id === Number(option?.value));
        if (selClass) {
          setTotSems(selClass.total_semester);
          const structure =
            selClass?.course_structure === 'year'
              ? selClass.course_structure.toUpperCase()
              : selClass?.course_structure?.slice(0, 3).toUpperCase();
          setCourseFormat(structure || 'SEM');
          fetchBatches(option?.value, '');
        }

        updated.course_name = option?.label ?? '';
        updated.batch_id = '';
        updated.batch_name = '';
      }
      if (field === 'faculty_selection_id') {
        updated.faculty_name = option?.label ?? '';
        setBatchMasterData((prev) => ({
          ...prev,
          faculty_id: option?.value || 0,
        }));
      }
      if (field === 'batch_id') {
        // DB me sirf original batch_name (e.g. "TRP123")
        updated.batch_name = option?.nameOnly || option?.label || '';
      }

      return updated;
    });

    if (field === 'course_selection_id') {
      const course_selection_id = option?.value || '';
      if (course_selection_id) {
        loadBatchesByCourse(course_selection_id);
      } else {
        setBatches([]);
      }
    }
  };

  const onAdmissionInputChange = (event, newInputValue) => {
    if (isSuperAdmin) {
      if (!formData.vendor_id || Number(formData.vendor_id) <= 0) {
        toast.error('Please select a Vendor');
        return;
      }
    }

    // Admin OR multi-branch user → must select branch
    if (isSuperAdmin || isAdmin || hasMultiBranch) {
      // Validate Semester (must be a number > 0)
      if (!formData.branch_id || Number(formData.branch_id) <= 0) {
        toast.error('Please select a Branch');
        return;
      }
    }
    GetAdmission(newInputValue, newInputValue);

    setFormData((prev) => ({
      ...prev,
      admit_no: newInputValue,
    }));
  };

  const onAdmissionChange = (event, newValue) => {
    if (newValue) {
      setAutoCompleteValue(newValue);
      setFormData((prev) => ({
        ...prev,
        admit_no: newValue.admit_no || '',
        student_id: newValue.id ? String(newValue.id) : prev.student_id,
        student_name: newValue.stud_name || prev.student_name,
        admit_no: newValue.admit_no || prev.admit_no,
      }));
    } else {
      setAutoCompleteValue(null);
      setFormData((prev) => ({
        ...prev,
        admit_no: '',
        student_id: '',
        student_name: '',
        admit_no: '',
      }));
    }
  };

  const submitForm = async () => {
    try {
      // Clear previous errors
      const newErrors = {};

      // Vendor validation
      if (isSuperAdmin) {
        if (!formData.vendor_id || Number(formData.vendor_id) <= 0) {
          newErrors.vendor_id = 'Please select a Vendor';
        }
      }

      // Branch validation
      if (isSuperAdmin || isAdmin || hasMultiBranch) {
        if (!formData.branch_id || Number(formData.branch_id) <= 0) {
          newErrors.branch_id = 'Please select a Branch';
        }
      }

      // Admission Number validation
      if (!formData.admit_no || !formData.admit_no.trim()) {
        newErrors.admit_no = 'Admission Number is required';
      }

      // Student ID validation (must be selected from autocomplete)
      if (!formData.student_id || !String(formData.student_id).trim()) {
        newErrors.student_id =
          'Please select a valid admission number from the list';
      }

      // Course validation
      if (
        !formData.course_selection_id ||
        !String(formData.course_selection_id).trim()
      ) {
        newErrors.course_selection_id = 'Course is required';
      } else if (Number(formData.course_selection_id) <= 0) {
        newErrors.course_selection_id = 'Please select a valid course';
      }

      // Faculty validation
      // if (!formData.faculty_selection_id || !String(formData.faculty_selection_id).trim()) {
      //   newErrors.faculty_selection_id = "Faculty is required";
      // } else if (Number(formData.faculty_selection_id) <= 0) {
      //   newErrors.faculty_selection_id = "Please select a valid faculty";
      // }

      // Batch validation
      if (!formData.batch_id || !String(formData.batch_id).trim()) {
        newErrors.batch_id = 'Batch is required';
      } else if (Number(formData.batch_id) <= 0) {
        newErrors.batch_id = 'Please select a valid batch';
      }

      // Admit No validation
      if (!formData.admit_no || !String(formData.admit_no).trim()) {
        newErrors.admit_no = 'Admission number (admit_no) is required';
      }

      // If there are validation errors, set them and return
      if (Object.keys(newErrors).length > 0) {
        setErrorMessage(newErrors);
        console.log('Validation errors:', newErrors);
        toast.error('Please fill all required fields correctly');
        return;
      }

      // Clear errors if validation passes
      setErrorMessage({});

      const payload = {
        ...formData,
        session_year: formData.session_year
          ? String(formData.session_year)
          : null,

        // IDs numeric form me
        student_id: formData.student_id ? parseInt(formData.student_id) : 0,
        batch_id: formData.batch_id ? parseInt(formData.batch_id) : 0,
        course_selection_id: formData.course_selection_id
          ? parseInt(formData.course_selection_id)
          : 0,
        faculty_selection_id: formData.faculty_selection_id
          ? parseInt(formData.faculty_selection_id)
          : 0,

        fee_group_id: formData.fee_group_id
          ? parseInt(formData.fee_group_id)
          : 0,
        slab_id: formData.slab_id ? parseInt(formData.slab_id) : 0,

        // admit_no string hi
        admit_no: formData.admit_no || null,
        student_name: formData.student_name || null,
        batch_name: formData.batch_name || null,
        course_name: formData.course_name || null,
        faculty_name: formData.faculty_name || null,
        disc_applicable: formData.disc_applicable || null,
        disc_recommended_by: formData.disc_recommended_by || null,
        disc_remark: formData.disc_remark || null,
      };
      // console.log("payload",payload);
      // return;
      let response;
      if (editData && (editData.enrollmentId || editData.enrollment_id)) {
        const id = editData.enrollmentId ?? editData.enrollment_id;
        response = await apiService.put(
          `api/Enrollment/UpdateEnrollment?id=${id}`,
          payload,
        );
      } else {
        response = await apiService.post(
          'api/Enrollment/AddEnrollment',
          payload,
        );
      }

      if (response.status === true) {
        toast.success(response.message || 'Saved Successfully');
        navigate('/enrollment-list');
      } else {
        toast.error(response.message || 'Failed');
      }
    } catch (e) {
      console.log(e);
      toast.error('Something went wrong.');
    }
  };

  // const onHandleMultipleValue = (param) => {
  //   // setPopupVisible(true);
  //   setModal(!modal);
  //   setMulti_Purpose_Type_MasterData((prevData) => ({
  //     ...prevData,
  //     multi_purpose_flag: param,
  //   }));
  //   //console.log(admissionData);
  //   // navigate('/save_multi_purpose_master', {
  //   //   state: { admissionData: admissionData, type: param },
  //   // });
  // };

  const Get_All_Multi_Purpose_Type_Master = async () => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };
      const response = await apiService.get(
        `api/Multi_Purpose_Type_Master/Get_All_Multi_Purpose_Type_Master`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }
      if (response.status === true) {
        ////
        setMultiPurposeMaster(response.data);

        // setReligionList(
        //   response.data.filter((item) => item.multi_purpose_flag === 'Religion')
        // );
        // setCategoryList(
        //   response.data.filter(
        //     (item) => item.multi_purpose_flag === 'Category_Financial'
        //   )
        // );
        // setMotherTongueList(
        //   response.data.filter(
        //     (item) => item.multi_purpose_flag === 'MotherTongue'
        //   )
        // );
        setBankList(
          response.data.filter((item) => item.multi_purpose_flag === 'Bank'),
        );
        // setQualificationList(
        //   response.data.filter(
        //     (item) => item.multi_purpose_flag === 'Qualification'
        //   )
        // );
        // setProfList(
        //   response.data.filter(
        //     (item) => item.multi_purpose_flag === 'Profession'
        //   )
        // );
        // //debugger;
        // const carOption = response.data
        //   .filter((item) => {
        //     return item.multi_purpose_flag === 'CarName';
        //   })
        //   .map((profile) => ({
        //     value: profile.multi_purpose_type,
        //     label: profile.multi_purpose_type,
        //   }));
        // setcarOptions(carOption);
        //updateHeaderData();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error('SomeThing went wrong!!');
    }
  };

  const GetFee_GroupData = async () => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/FeeGroupMaster/GetFeeGroup?vendorId=${formData.vendor_id}&branchId=${formData.branch_id}`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        setFee_Group_data(response.data);
        // setTotalPage(response.totalPages);
      } else {
        console.log(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error('SomeThing went wrong!!');
    }
  };

  const GetSlabMasterByFeeGroupID = async (groupId, classId) => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };
      const response = await apiService.get(
        `api/SlabMaster/GetSlabMasterByFeeGroupID?fee_group_id=${groupId}&class_id=${classId}&session=${sessionData.session_year}`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }
      if (response.slab_Master_List.length === 0) {
        toast.error('Fee Slab does not exist for this course or fee group');
      }
      if (response.status === true) {
        // console.log(response,"response fee slab")
        setSlabMasterList(response.slab_Master_List);
        // const filterDate = response.slab_Master_List.find(
        //   (s) => s.id === parseInt(location.state?.slab_id)
        // );
        // if (filterDate) {
        //   setSlabMasterTotalMont(filterDate);
        // }
        //GetMonthlyFeeStructure();   //slab monthly fee data

        //updateHeaderData();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error('SomeThing went wrong!!');
    }
  };

  const onChangeHandle = (e) => {
    const { name, value } = e.target;

    if (name === 'fee_group_id') {
      if (
        !formData.course_selection_id ||
        Number(formData.course_selection_id) <= 0
      ) {
        toast.error('Please select course first');
        return; // Stop further execution
      }
      if (value <= 0) {
        toast.error('Please select fee group to load fee details');
        //return; // Stop further execution
      }
      GetSlabMasterByFeeGroupID(value, formData.course_selection_id);

      //setSlabMasterTotalMont({});
    }
    if (name === 'slab_id') {
      const filterData = SlabMasterList.find((s) => s.id === parseInt(value));
      if (filterData) {
        setFormData((prevData) => ({
          ...prevData,
          total_semester: filterData.total_semester,
          slab_fee_tot: filterData.fee_tot,
          fee_tot: filterData.fee_tot,

          disc_tot: 0,
          month_tot_1: filterData.month_tot_1,
          month_tot_2: filterData.month_tot_2,
          month_tot_3: filterData.month_tot_3,
          month_tot_4: filterData.month_tot_4,
          month_tot_5: filterData.month_tot_5,
          month_tot_6: filterData.month_tot_6,
          month_tot_7: filterData.month_tot_7,
          month_tot_8: filterData.month_tot_8,
          month_tot_9: filterData.month_tot_9,
          month_tot_10: filterData.month_tot_10,
          month_tot_11: filterData.month_tot_11,
          month_tot_12: filterData.month_tot_12,
        }));

        // fee structure details
        setFeeDueList(
          filterData.slab_Detail_Masters.map((item) => ({
            ...item, // keep existing data as it is
            disc_amt: 0, // add new key with any default value
            disc_circle_name: '',
          })),
        );
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const generateInstallments = async () => {
    try {
      const response = await apiService.get(
        `api/Enrollment/GenerateInstallments?enrollmentId=${formData.enrollment_id}&installmentType=${installmentType}`,
      );

      if (response.response && response.response.data?.errors) {
        toast.error(response.response.data.errors);
      }

      if (response.status === true) {
        setInstallmentList(response.studentFeeInstallments);
      } else {
        toast.error(response.message || 'Failed to fetch');
      }
    } catch (error) {
      console.error(error);
      toast.error('SomeThing went wrong');
    }
  };

  return (
    <>
      <div className='bg-white pd-5 card-box mb-5 toolbar-row sticky-top border text-right mb-3'>
        <Button size='sm' color='primary' onClick={submitForm}>
          {editData ? 'Update' : 'Create'} Enrollment{' '}
          <i className='bi bi-check-circle ms-2' />
        </Button>
        &nbsp;
        <Button color='warning' size='sm' onClick={onHandleBack}>
          <i className='bi bi-arrow-left ms-2' /> Back
        </Button>
        {/* ✅ Create Student Credentials button */}
        {Number(formData.enrollment_id) > 0 && (
          <Button
            size='sm'
            color='success'
            className='ms-2'
            onClick={handleCreateStudentCredentials}
            disabled={credLoading || isCredSubmitting}
          >
            <i className='bi bi-key' />{' '}
            {credLoading ? 'Creating...' : 'Create Student Credentials'}
          </Button>
        )}
      </div>
      <VendorBranchSelector
        user={user}
        selectionData={formData}
        setSelectionData={setFormData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <Card className='card-box pd-20 mb-20'>
        <CardTitle
          tag='h6'
          className='border-bottom p-3 mb-0 d-flex justify-content-between align-items-center'
        >
          <span>
            <i className='bi bi-pencil-square mr-2' />
            {editData ? 'Edit Enrollment' : 'Add Enrollment'}
          </span>
        </CardTitle>

        <CardBody>
          <Form>
            <Row>
              <FormGroup className='col-sm-4'>
                <Label>Admission No.</Label>
                <Autocomplete
                  id='admit_no'
                  options={studRecords}
                  value={autoCompleteValue}
                  getOptionLabel={(option) =>
                    (option.admit_no || '') +
                    ' - ' +
                    (option.stud_name || '') +
                    ' - ' +
                    (option.stud_ph_no || '')
                  }
                  onChange={onAdmissionChange}
                  onInputChange={onAdmissionInputChange}
                  openOnFocus
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder='Search Adm.no., Name, Mobile no., etc'
                      variant='outlined'
                      error={
                        !!errorMessage.admit_no || !!errorMessage.student_id
                      }
                      helperText={
                        errorMessage.admit_no ||
                        errorMessage.student_id ||
                        errorMessage.admit_no
                      }
                      sx={{
                        '& .MuiInputBase-root': {
                          height: '36px',
                          fontSize: '14px',
                          borderRadius: '4px',
                        },
                        '& .MuiOutlinedInput-input': {
                          padding: '8px',
                        },
                      }}
                    />
                  )}
                />
              </FormGroup>

              <FormGroup className='col-sm-4'>
                <Label>Course</Label>
                <Select
                  options={classes}
                  value={classes.find(
                    (o) => o.value === formData.course_selection_id,
                  )}
                  onChange={(opt) => onSelectChange('course_selection_id', opt)}
                  onInputChange={(inputValue, actionMeta) => {
                    if (actionMeta.action === 'input-change') {
                      fetchClasses(inputValue);
                    }
                  }}
                  isSearchable
                  isClearable
                  placeholder='Search courses ...'
                />
                {errorMessage.course_selection_id && (
                  <FormText color='danger'>
                    {errorMessage.course_selection_id}
                  </FormText>
                )}
              </FormGroup>

              <FormGroup className='col-sm-4'>
                <Label>
                  Batch
                  <i
                    style={{ cursor: 'pointer' }}
                    onClick={toggleBatchModal}
                    className='bi bi-question-circle text-primary float-end ml-2'
                    title='Add new Batch'
                  />
                </Label>
                <Select
                  options={batches}
                  value={batches.find((x) => x.value === formData.batch_id)}
                  onChange={(opt) => onSelectChange('batch_id', opt)}
                  onInputChange={(inputValue, actionMeta) => {
                    if (actionMeta.action === 'input-change') {
                      fetchBatches(formData.course_selection_id, inputValue);
                    }
                  }}
                  isSearchable
                  isClearable
                  placeholder='Search batches ...'
                />
                {errorMessage.batch_id && (
                  <FormText color='danger'>{errorMessage.batch_id}</FormText>
                )}
              </FormGroup>

              {/* <FormGroup className='col-sm-4'>
                <Label>Session Year</Label>

                <Select
                  options={sessionOptions}
                  value={sessionOptions.find(
                    (o) => String(o.label) === String(formData.session_year),
                  )}
                  onChange={(opt) =>
                    setFormData((prev) => ({
                      ...prev,

                      session_year: opt ? String(opt.label) : '',
                    }))
                  }
                  onInputChange={(inputValue, actionMeta) => {
                    if (actionMeta.action === 'input-change') {
                      fetchSessions(inputValue);
                    }
                  }}
                  isSearchable
                  isClearable
                  placeholder='Select session (e.g. 2025-2026)'
                />

                {errorMessage.session_year && (
                  <FormText color='danger'>
                    {errorMessage.session_year}
                  </FormText>
                )}
              </FormGroup> */}
            </Row>
            {errorMessage.submit && (
              <div className='alert alert-danger mb-3' role='alert'>
                <i className='bi bi-exclamation-triangle mr-2' />
                {errorMessage.submit}
              </div>
            )}
          </Form>
        </CardBody>
      </Card>

      <Card className='card-box height-100-p pd-20 mb-20'>
        <CardTitle
          tag='h6'
          className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
        >
          <div className='d-flex align-items-center'>
            <i className='bi bi-currency-rupee mr-2'></i>
            Fees Details
          </div>
        </CardTitle>

        <CardBody>
          {/* <div className='row'>


            <div className='col-sm-4'>
              <FormGroup>
                <Label for='bank_name'>
                  Bank
                </Label>

              <i className="bi bi-question-circle float-end text-primary"
                      onClick={() => onHandleMultipleValue('Bank')}>
                    </i> 
                <select
                  className='custom-select'
                  id='bank_name'
                  name='bank_name'
                  value={formData.bank_name}
                  onChange={onChangeHandle}
                >
                  <option value='0'>Select Bank</option>
                  {bankList.map((option) => (
                    <option
                      key={option.multi_purpose_type}
                      value={option.multi_purpose_type}
                    >
                      {option.multi_purpose_type}
                    </option>
                  ))}
                </select>
                {errorMessage.bank_name && (
                  <FormText color='danger'>
                    {errorMessage.bank_name}
                  </FormText>
                )}
              </FormGroup>
            </div>

            <div className='col-sm-4'>
              <FormGroup>
                <Label for='bank_ac_no'>Bank A/C No.</Label>
                <Input
                  id='bank_ac_no'
                  name='bank_ac_no'
                  value={formData.bank_ac_no}
                  onChange={onChangeHandle}
                />
                {errorMessage.name && (
                  <FormText color='danger'>
                    {errorMessage.bank_ac_no}
                  </FormText>
                )}
              </FormGroup>
            </div>
            <div className='col-sm-4'>

              <FormGroup>
                <Label for='op_bal'>Fees Opening Balance</Label>
                <Input
                  id='op_bal'
                  name='op_bal'
                  value={formData.op_bal}
                  onChange={onChangeHandle}
                />
                {errorMessage.name && (
                  <FormText color='danger'>
                    {errorMessage.op_bal}
                  </FormText>
                )}
              </FormGroup>
            </div>
          </div> */}

          <div className='row'>
            <div className='col-sm-6'>
              <FormGroup>
                <Label for='fee_group_id'>Fee Group Name</Label>
                <select
                  className='custom-select'
                  id='fee_group_id'
                  name='fee_group_id'
                  value={formData.fee_group_id}
                  onChange={onChangeHandle}
                >
                  <option value='0'>-Select Fee Group</option>
                  {Fee_Group_data.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.fee_group_name}
                    </option>
                  ))}
                </select>

                {errorMessage.fee_group_id && (
                  <FormText color='danger'>
                    {errorMessage.fee_group_id}
                  </FormText>
                )}
              </FormGroup>
            </div>
            <div className='col-sm-6'>
              <FormGroup>
                <Label for='slab_id'>Fees Slab Name</Label>
                <select
                  className='custom-select'
                  id='slab_id'
                  name='slab_id'
                  value={formData.slab_id}
                  onChange={onChangeHandle}
                >
                  <option value='0'>-Select Fee Slab-</option>
                  {SlabMasterList.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.slab_name}
                    </option>
                  ))}
                </select>

                {errorMessage.slab_id && (
                  <FormText color='danger'>{errorMessage.slab_id}</FormText>
                )}
              </FormGroup>
            </div>
            {/* <div className='col-sm-4'>

              <FormGroup>
                <Label for='barcode_no'>BarCode</Label>
                <Input
                  id='barcode_no'
                  name='barcode_no'
                  value={formData.barcode_no}
                  onChange={onChangeHandle}
                  type='text'
                />
                {errorMessage.barcode_no && (
                  <FormText color='danger'>
                    {errorMessage.barcode_no}
                  </FormText>
                )}
              </FormGroup>
            </div> */}
          </div>

          <div className='row'>
            <div className='col-sm-4'>
              <FormGroup>
                <Label for='disc_applicable'>Discount Applicable?</Label>
                <Input
                  id='disc_applicable'
                  name='disc_applicable'
                  value={formData.disc_applicable}
                  onChange={onChangeHandle}
                  type='select'
                  className='custom-select'
                >
                  <option value=''>-Select-</option>
                  <option value='yes'>Yes</option>
                  <option value='no'>No</option>
                </Input>
                {errorMessage.disc_applicable && (
                  <FormText color='danger'>
                    {errorMessage.disc_applicable}
                  </FormText>
                )}
              </FormGroup>
            </div>

            {formData.disc_applicable === 'yes' && (
              <>
                <div className='col-sm-4'>
                  <FormGroup>
                    <Label for='disc_recommended_by'>Recommended by</Label>
                    <Input
                      id='disc_recommended_by'
                      name='disc_recommended_by'
                      value={formData.disc_recommended_by}
                      onChange={onChangeHandle}
                      type='text'
                    />
                    {errorMessage.disc_recommended_by && (
                      <FormText color='danger'>
                        {errorMessage.disc_recommended_by}
                      </FormText>
                    )}
                  </FormGroup>
                </div>

                <div className='col-sm-4'>
                  <FormGroup>
                    <Label for='disc_remark'>Remark</Label>
                    <Input
                      id='disc_remark'
                      name='disc_remark'
                      value={formData.disc_remark}
                      onChange={onChangeHandle}
                      type='text'
                    />
                    {errorMessage.disc_remark && (
                      <FormText color='danger'>
                        {errorMessage.disc_remark}
                      </FormText>
                    )}
                  </FormGroup>
                </div>
              </>
            )}
          </div>

          {/* {user?.working_bussinesss_mode !== "SCHOOL" && ( */}
            <>
            <div className='mt-3 mb-3'>
            <h5>Fee-Structure for the current slab is as follows: </h5>
            <h6 className='text-right'>
              {' '}
              Total Fees:{' '}
              <span className='text-danger'>₹{formData?.fee_tot}</span>
            </h6>
          </div>
       
          <div className='table-responsive border-top compact-table'>
            <Table hover striped responsive bordered>
              <thead className='bg-primary text-white'>
                <tr>
                  <th>#</th>
                  {(isAdmin || isSuperAdmin) &&
                    formData.enrollment_id > 0 &&
                    formData.disc_applicable === 'yes' && <th> Apply</th>}
                  <th>Fee Head</th>
                  <th>Fee Circle</th>
                  <th>Fee Amt</th>
                  <th>Disc Amt</th>
                  {Array.from({ length: totSems || 0 }, (_, i) => (
                    <th key={i}>
                      {courseFormat}-{i + 1}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {feeDueList?.length > 0 ? (
                  feeDueList.map((rows, index) => (
                    <tr>
                      <td>{index + 1}</td>

                      {(isAdmin || isSuperAdmin) &&
                        formData.enrollment_id > 0 &&
                        formData.disc_applicable === 'yes' && (
                          <td
                            onClick={toggleDiscountModal.bind(this, rows)}
                            style={{ cursor: 'pointer' }}
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            title='Apply Discount'
                            className='text-primary'
                          >
                            Disc. <i className='bi bi-tags-fill' />
                          </td>
                        )}

                      <td>{rows.fee_head_name}</td>
                      <td>{rows.circle}</td>
                      <td>₹{rows.fee_amt}</td>
                      <td
                        style={{
                          maxWidth: '120px',
                          wordWrap: 'break-word',
                        }}
                      >
                        ₹{rows.disc_amt}
                        {rows.disc_circle_name
                          ? ` - ${rows.disc_circle_name.trim()}`
                          : ''}
                      </td>

                      {Array.from({ length: totSems || 0 }, (_, i) => (
                        <td key={i} className=' text-right'>
                          ₹{rows[`month_${i + 1}`]}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className='text-center' colSpan={17}>
                      No Fee Heads Added till now under this slab...
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot>
                <tr>
                  <th
                    colSpan={
                      (isAdmin || isSuperAdmin) &&
                      formData.enrollment_id > 0 &&
                      formData.disc_applicable === 'yes'
                        ? 6
                        : 5
                    }
                    className='text-right'
                  >
                    Sub-Total ({courseFormat}-WISE){' '}
                  </th>
                  {Array.from({ length: totSems || 0 }, (_, i) => (
                    <td key={i} className='text-right fw-bold text-primary'>
                      ₹{formData[`month_tot_${i + 1}`]}
                    </td>
                  ))}
                </tr>
                <tr className='border-top'>
                  <th
                    colSpan={
                      (isAdmin || isSuperAdmin) &&
                      formData.enrollment_id > 0 &&
                      formData.disc_applicable === 'yes'
                        ? 5 + (totSems || 0)
                        : 4 + (totSems || 0)
                    }
                    className='text-right text-primary'
                  >
                    Grand Total
                  </th>
                  <th className='text-danger text-right'>
                    ₹{formData?.fee_tot}
                  </th>
                </tr>
              </tfoot>
            </Table>
          </div>
            </>
           {/* )} */}
        </CardBody>
      </Card>

      {formData.enrollment_id > 0 && (
        <Card className='card-box height-100-p pd-20 mb-20'>
          <CardTitle
            tag='h6'
            className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
          >
            <div className='d-flex align-items-center'>
              <i className='bi bi-currency-rupee mr-2'></i>
              Fees Installments Structure
            </div>
          </CardTitle>

          <CardBody>
            <div className='row'>
              <div className='col-sm-8'>
                <FormGroup>
                  <Label for='installmentType'>Installment Type</Label>
                  <select
                    className='custom-select'
                    id='installmentType'
                    name='installmentType'
                    value={formData?.fee_installment_mode}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        fee_installment_mode: e.target.value,
                      }));
                      setInstallmentType(e.target.value);
                    }}
                  >
                    <option value=''>-- Select Type --</option>
                    <option value='monthly'>Monthly</option>
                    <option value='quarterly'>Quarterly</option>
                    <option value='half-yearly'>Half-Yearly</option>
                    <option value='yearly'>Yearly</option>
                    <option value='lump-sum'>Lump-sum</option>
                  </select>

                  {errorMessage.installmentType && (
                    <FormText color='danger'>
                      {errorMessage.installmentType}
                    </FormText>
                  )}
                </FormGroup>
              </div>

              <div className='col-sm-3'>
                <FormGroup>
                  <Label for='fee_group_id'>Action</Label>
                  <Button
                    size='sm'
                    className='form-control text-light'
                    color='success'
                    onClick={generateInstallments}
                  >
                    {' '}
                    <i className='bi bi-check-circle mr-2' />
                    Generate Installments
                  </Button>
                </FormGroup>
              </div>
            </div>

            {installmentList?.length > 0 ? (
              <>
                {/* Slab Info */}
                <div className='d-flex justify-content-between align-items-center mb-2'>
                  <span className='small text-muted'>
                    Slab Name :
                    <strong className='ms-1 text-dark'>
                      {formData?.slab_name}
                    </strong>
                  </span>
                </div>

                {/* Installments Table */}
                <div className='table-responsive'>
                  <table className='table table-sm table-hover align-middle compact-table mb-2'>
                    <thead className='table-light'>
                      <tr>
                        <th>Inst no.</th>
                        <th>Mode</th>
                        <th>Due Date</th>
                        <th>Period</th>
                        <th>Status</th>
                        <th className='text-right'>Amount</th>
                      </tr>
                    </thead>

                    <tbody>
                      {installmentList.map((row, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>

                          <td>{row.inst_type.toUpperCase()}</td>

                          <td>{formatDate(row.inst_due_date)}</td>
                          <td>{row.inst_name}</td>

                          <td>
                            <span
                              className={`badge rounded-pill px-2 py-1 text-light small"
                                        ${
                                          row.status === 'Paid'
                                            ? 'bg-success'
                                            : row.status === 'Partial'
                                              ? 'bg-warning text-dark'
                                              : 'bg-danger'
                                        }`}
                            >
                              {row.status}
                            </span>
                          </td>
                          <td className='text-right fw-semibold'>
                            ₹{row.cr_amt}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Summary Section */}
                <div className='border-top pt-2'>
                  <div className='d-flex justify-content-between small'>
                    <span>Total Fees</span>
                    <span className='fw-semibold'>₹{formData?.fee_tot}</span>
                  </div>

                  <div className='d-flex justify-content-between small text-success'>
                    <span>Paid Till Now</span>
                    <span className='fw-semibold'>₹{formData?.paid_amt}</span>
                  </div>

                  <div className='d-flex justify-content-between fw-bold text-danger border-top pt-1 mt-1'>
                    <span>Total Dues Left</span>
                    <span>₹{formData?.outstanding}</span>
                  </div>
                </div>
              </>
            ) : (
              /* Empty State */
              <div className='text-center py-4 text-muted'>
                <i className='bi bi-info-circle fs-4 d-block mb-1'></i>
                <p className='mb-0'>No installment details available</p>
                <small>Please select a valid Enrollment No.</small>
              </div>
            )}
          </CardBody>
        </Card>
      )}
      {/* Batch Add Modal */}
      <Modal centered isOpen={batchModal} toggle={toggleBatchModal} size='lg'>
        <ModalHeader toggle={toggleBatchModal}>
          Add new Batch for Course - {formData.course_name}
        </ModalHeader>
        <ModalBody>
          <Form className='row'>
            <FormGroup className='col-12'>
              <Label htmlFor='batch_name'>Batch Name</Label>
              <Input
                id='batch_name'
                name='batch_name'
                value={batchMasterData.batch_name}
                onChange={onBatchInputChange}
              />
              {batchErrors.batch_name && (
                <FormText color='danger'>{batchErrors.batch_name}</FormText>
              )}
            </FormGroup>

            <FormGroup className='col-6'>
              <Label htmlFor='batch_code'>Batch Code</Label>
              <Input
                id='batch_code'
                name='batch_code'
                value={batchMasterData.batch_code}
                onChange={onBatchInputChange}
              />
              {batchErrors.batch_code && (
                <FormText color='danger'>{batchErrors.batch_code}</FormText>
              )}
            </FormGroup>

            <FormGroup className='col-6'>
              <Label>Head Faculty </Label>
              <Select
                options={faculty}
                value={faculty.find(
                  (x) => x.value === batchMasterData.faculty_id,
                )}
                //value={formData.faculty_selection_id}
                onChange={(opt) => onSelectChange('faculty_selection_id', opt)}
                onInputChange={(inputValue, actionMeta) => {
                  if (actionMeta.action === 'input-change') {
                    fetchFaculty(inputValue);
                  }
                }}
                isSearchable
                isClearable
                placeholder='Select faculty'
              />
              {batchErrors.faculty_id && (
                <FormText color='danger'>{batchErrors.faculty_id}</FormText>
              )}
            </FormGroup>

            <TimeSelector
              label='Batch Start Time'
              value={batchMasterData.batch_start_time}
              col={'col-6'}
              onChange={(val) =>
                setBatchMasterData((prev) => ({
                  ...prev,
                  batch_start_time: val,
                }))
              }
              errorMsg={batchErrors.batch_start_time}
            />

            <TimeSelector
              label='Batch End Time'
              value={batchMasterData.batch_end_time}
              col={'col-6'}
              onChange={(val) =>
                setBatchMasterData((prev) => ({ ...prev, batch_end_time: val }))
              }
              errorMsg={batchErrors.batch_end_time}
            />

            <FormGroup className='col-6'>
              <Label htmlFor='batch_start_date'>Batch Start Date</Label>
              <Input
                id='batch_start_date'
                name='batch_start_date'
                type='date'
                value={batchMasterData.batch_start_date}
                onChange={onBatchInputChange}
              />
              {batchErrors.batch_start_date && (
                <FormText color='danger'>
                  {batchErrors.batch_start_date}
                </FormText>
              )}
            </FormGroup>

            <FormGroup className='col-6'>
              <Label htmlFor='batch_end_date'>Batch End Date</Label>
              <Input
                id='batch_end_date'
                name='batch_end_date'
                type='date'
                value={batchMasterData.batch_end_date}
                onChange={onBatchInputChange}
              />
              {batchErrors.batch_end_date && (
                <FormText color='danger'>{batchErrors.batch_end_date}</FormText>
              )}
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color='primary' onClick={saveBatchMaster}>
            Submit
          </Button>
          <Button color='secondary' onClick={toggleBatchModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      {/* Discount Add Modal */}
      <Modal centered isOpen={discountModal} toggle={toggleDiscountModal}>
        <ModalHeader toggle={toggleDiscountModal}>Add Discount</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label htmlFor='disc_amt'>Discount Amount</Label>
              <Input
                id='disc_amt'
                name='disc_amt'
                value={discountMasterData.disc_amt}
                onChange={onDiscInputChange}
              />
              {discountErrors.disc_amt && (
                <FormText color='danger'>{discountErrors.disc_amt}</FormText>
              )}
            </FormGroup>

            <FormGroup>
              <Label htmlFor='disc_circle_id'>Applicable for</Label>
              <Input
                id='disc_circle_id'
                name='disc_circle_id'
                type='select'
                className='custom-select'
                value={discountMasterData.disc_circle_id}
                onChange={onDiscInputChange}
              >
                <option value='0'>-Select-</option>
                {circleTable.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.circle_name}
                  </option>
                ))}
              </Input>
              {discountErrors.disc_circle_id && (
                <FormText color='danger'>
                  {discountErrors.disc_circle_id}
                </FormText>
              )}
            </FormGroup>
            <FormGroup>
              <Label htmlFor='disc_remark'>Discount Remark</Label>
              <Input
                id='disc_remark'
                name='disc_remark'
                value={discountMasterData.disc_remark}
                onChange={onDiscInputChange}
              />
              {discountErrors.disc_remark && (
                <FormText color='danger'>{discountErrors.disc_remark}</FormText>
              )}
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color='primary' onClick={saveDiscount}>
            Submit
          </Button>
          <Button color='secondary' onClick={toggleDiscountModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default EnrollmentForm;
